var module = angular.module('octopusApp.library');

module.controller('TagSetsIndexController', function($scope, $location, $state, busy, octopusRepository, octoDialog, unsavedChanges) {
    var isLoading = $scope.isLoading = busy.create();
    isLoading.promise(octopusRepository.TagSets.list({contentType: 'TagSets'}).then(function (tagSets) {
        $scope.tagSets = tagSets;
    }));

    $scope.reorder = function() {
        octoDialog.sort({
            title: "Reorder Tag Sets",
            saveButtonText: "Save",
            load: function(dialog) {
                dialog.render(_.map($scope.tagSets.Items, function (tagSet) {
                    return {
                        id: tagSet.Id,
                        name: tagSet.Name
                    };
                }));
            },
            save: function (items, dialog) {
                dialog.busy.promise(octopusRepository.TagSets.sort(items).then(function() {
                    dialog.dismiss();
                    //$state.reload();
                    unsavedChanges.saved();
                }));
            }
        });
    };
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/library/tagsets/controllers/tagsets_index_controller.js
// module id = 472
// module chunks = 1